import React from 'react';

import { SVGPropsType } from 'src/types';

function ColumnsChart(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M9.3002 3.20001H6.7002V12.8H9.3002V3.20001Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M4.2001 7.5H1.6001V12.9H4.2001V7.5Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M14.4003 9.70001H11.8003V12.9H14.4003V9.70001Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
        </svg>
    );
}

export default ColumnsChart;
